import { useEffect, useRef } from 'react';
import { usePreferences } from '../contexts/PreferenceContext';

const normalizeScopeId = (scope) => {
  const entityId = Number(scope?.entityId);
  return Number.isInteger(entityId) && entityId > 0 ? String(entityId) : null;
};

const PreferenceLoader = ({
  token,
  scope,
  settingsScope = scope,
  globalPreferenceCarrierScope = scope
}) => {
  const { loadPreferences } = usePreferences();
  const loadedPersonalIdentityRef = useRef(null);
  const loadedCarrierScopeRef = useRef(null);
  const loadedSettingsScopeRef = useRef(null);
  const preferenceEntityId = normalizeScopeId(scope);
  const carrierEntityId = normalizeScopeId(globalPreferenceCarrierScope);
  const settingsEntityId = normalizeScopeId(settingsScope);
  
  useEffect(() => {
    if (!token) {
      loadedPersonalIdentityRef.current = null;
      loadedCarrierScopeRef.current = null;
      loadedSettingsScopeRef.current = null;
      return;
    }

    const personalIdentity = `${carrierEntityId || 'none'}:${preferenceEntityId || 'none'}`;
    const personalIdentityChanged = loadedPersonalIdentityRef.current !== personalIdentity;
    const shouldLoadPersonal = (
      carrierEntityId !== null &&
      loadedCarrierScopeRef.current !== carrierEntityId
    );
    const shouldLoadSettings = (
      settingsEntityId !== null &&
      loadedSettingsScopeRef.current !== settingsEntityId
    );

    loadedPersonalIdentityRef.current = personalIdentity;
    loadedCarrierScopeRef.current = carrierEntityId;
    loadedSettingsScopeRef.current = settingsEntityId;

    if (!personalIdentityChanged && !shouldLoadPersonal && !shouldLoadSettings) {
      return;
    }

    // Personal preferences and readable entity settings have different
    // authorization provenance, so each deduplication identity selects only
    // its own request slice.
    loadPreferences({
      loadPersonal: shouldLoadPersonal,
      loadSettings: shouldLoadSettings,
      selectedPersonalChanged: personalIdentityChanged
    });
  }, [
    token,
    preferenceEntityId,
    settingsEntityId,
    carrierEntityId,
    loadPreferences
  ]);
  
  return null; // This component doesn't render anything
};

export default PreferenceLoader;
